import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Stack } from '@chakra-ui/react';

import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import BackButton from 'components/BackButton';
import Loader from 'components/Loader';
import * as Layout from 'layouts/StepperLayout';

import PhysicalCardQuotaReachedFaq from '../../components/PhysicalCardQuotaReachedFaq';
import usePaymentCardOrder from '../../hooks/usePaymentCardOrder';
import CardList from './components/CardList';
import ErrorView from './components/ErrorView';
import locales from './locales';

const PaymentCardOrder: FC = () => {
  const { goBack } = useHistory();

  const {
    canOrderPhysicalCard,
    error,
    firstPhysicalActivePaymentCardNumber,
    loading,
    refetch,
  } = usePaymentCardOrder();

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <ErrorView onGoBackPressed={goBack} retry={refetch} />;
  }

  return (
    <Layout.Root>
      <Layout.Body>
        <Layout.HeaderButtonsContainer>
          <BackButton onClick={goBack} />
        </Layout.HeaderButtonsContainer>

        <Layout.BodyScrollableSection>
          <Stack marginBottom="space-32" spacing="space-8">
            <Heading size="lg">{locales.title}</Heading>
            <Text size="md">{locales.description}</Text>
          </Stack>

          <CardList />

          {!canOrderPhysicalCard ? (
            <PhysicalCardQuotaReachedFaq
              cardNumber={firstPhysicalActivePaymentCardNumber}
              paddingTop="space-32"
            />
          ) : null}
        </Layout.BodyScrollableSection>
      </Layout.Body>
    </Layout.Root>
  );
};

export default PaymentCardOrder;
